import { WaLink } from '../data/const/about';

export const sendWhatsapp = (message: string) => {
  const encodedText: string = encodeURIComponent(message);
  return WaLink + '?text=' + encodedText;
};
